export default __webpack_public_path__ + "img/fAYniOzt.90fae3b7.svg";